import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { LoadingService } from '../../shared/services/loading.service';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [CommonModule, NzSpinModule],
  template: `
    <div class="global-loader" *ngIf="loadingService.isLoading()">
      <div class="loader-overlay">
        <div class="loader-content">
          <nz-spin nzSimple></nz-spin>
          <p class="loader-message" *ngIf="loadingService.loadingText()">{{ loadingService.loadingText() }}</p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .global-loader {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;
      pointer-events: none;
    }

    .loader-overlay {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: rgba(10, 16, 28, 0.42);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      pointer-events: auto;
    }

    .loader-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.8rem;
      padding: 0.75rem 1rem;
    }

    .loader-message {
      margin: 0;
      color: #ffffff;
      font-size: 0.95rem;
      font-weight: 600;
      letter-spacing: 0.01em;
    }

    ::ng-deep .ant-spin-spinning {
      color: var(--ion-color-primary, #3880ff);
    }
  `],
})
export class GlobalLoaderComponent {
  constructor(public loadingService: LoadingService) {}
}
